import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setPage, setSection } from '../../store/AppSlice';
import arnisdale_large from '../../img/village/arnisdale_large.jpg'
import arnisdale_medium from '../../img/village/arnisdale_medium.jpg'
import arnisdale_small from '../../img/village/arnisdale_small.jpg'

const GettingThere = () => {

  const dispatch = useDispatch();

  const navigateToLocation = () => {
    dispatch(setSection("COTTAGE"));
    dispatch(setPage("LOCATION"));
  }

  return (
    <div>
      <h2 className="your-stay-section-heading">Location</h2>
      <p className="your-stay-text">From the A87 take the turning at Shiel Bridge signposted Glenelg, Skye Ferry.
                                    Follow the single-track road all the way over Ratagan Pass, through
                                    Glenelg and on a further 9 miles to Arnisdale. It is approximately 19
                                    miles from the main road to the cottage and takes about 45 minutes.  The cottage postcode
                                    is IV40 8JL.  See the
                                    <span className="navigate-span"><a className="navigate-button" onClick={navigateToLocation}>location</a></span>
                                    section of the website for more info on routes and google maps.
      </p>
      <div className="row your-stay-image">
        <div className="col-12">
          <div className="imagesBackgroundColour">
            <picture>
              <source srcSet={`${arnisdale_small} 1x,${arnisdale_medium} 2x`} media="(max-width: 600px)" />
              <img srcSet={`${arnisdale_medium} 1x,${arnisdale_large} 2x`}
                src={arnisdale_medium} alt="View looking down on Arnisdale" className="image"
              />
            </picture>
          </div>             
        </div>
      </div>
    </div>
  );
}

export default GettingThere
